<template lang="pug">
  div(v-loading="loggingIn")
    el-row
      el-col(:xs='20', :sm='16', :md='14', :lg='10', :xl='8')
        el-dialog(
          style="word-break: break-word"
          :title="$t('new_app_title')",
          ref="dialogSelectAppType",
          :visible.sync='dialogSelectAppType',
          :width='dialogSelectAppTypeSize',
          :close-on-click-modal='false',
          :close-on-press-escape='false',
          :show-close='false',
          :center='true'
        )
          hr
          el-form(label-width='140px', v-loading="findingCreatingApp", :inline="true")
            el-form-item(label="Γλώσσα/Language", ref='languageSelect')
              el-radio-group(v-model='language' @change="changeLanguage")
                el-radio(label='el') Ελληνικά
                el-radio(label='en') English
            hr
            el-form-item(:label="$t('select')" ref='selectAppType')
              el-radio-group(v-model='pilotNewEdit', @change='findApplication')
                el-radio(label='new') {{ $t("newApp") }}
                el-radio(label='edit') {{ $t("myApps") }}
            template
              el-alert.wbreak(
                :closable='true'
                v-if="pilotNewEdit === 'edit'"
                :title="$t('myapps_warning')"
                type='success'
              )
              el-alert.wbreak(
                :closable='true'
                v-if="pilotNewEdit === 'new' && usersAllApplications.length !== 0"
                :title="$t('new_app_warning')"
                type='warning'
              )
              el-form-item(
                :label="$t('myApps')"
                v-if="pilotNewEdit === 'new' && usersAllApplications.length !== 0"
              )
                span(v-html='calcAllApps')
            div(v-show="pilotNewEdit === 'new'")
              el-form-item(:label="$t('type_of_app')")
                el-select.big(v-model='application.applicationType', :placeholder="$t('options')" @change='appTypeChanged')
                  el-option(:label="$t('recognition')", value='recognition')
                  el-option(:disabled='usersAllApplications.length === 0', :label="$t('reappraisal')", value='reappraisal')
                el-tooltip(placement='right')
                  div(slot='content')
                    span {{ $t("hint_app_type") }}
                  i.el-icon-question
              el-form-item(
                ref="studyLevel"
                :label="$t('level_of_study')",
                v-show='application.applicationType === "recognition"'
              )
                el-select.big(
                  v-model='application.degreeType',
                  :placeholder="$t('select_type')",
                  @change='degreeLevelChanged'
                )
                  el-option(:label="$t('bachelor')", value='bachelor')
                  el-option(:label="$t('master')", value='master')
                  el-option(:label="$t('phd')", value='phd')
                el-tooltip(placement='right')
                  div(slot='content')
                    span {{ $t("hint_levelof_studies") }}
                  i.el-icon-question
              el-form-item(:label="$t('myfinalizedApps')", v-loading='loadingFinalizedApps' v-show='application.applicationType === "reappraisal"')
                el-select.bigger(
                  v-model='relevantAppId',
                  :placeholder="$t('select')",
                  @change='reappraisalAppChanged'
                )
                  el-option(
                    v-for="reappraisalApp in finalizedApps",
                    :key="reappraisalApp.id",
                    :label="reappraisalApp.id + ':'+ reappraisalApp.applicationType",
                    :value="reappraisalApp.id"
                  )
                el-tooltip(placement='right')
                  div(slot='content')
                    span {{ $t("hint_reappraisal") }}
                  i.el-icon-question
              el-form-item(label=' ', v-if='stagingEnv && application.applicationType === "reappraisal"')
                el-checkbox(:label="$t('force_overdue')", v-model='forceOverdue')
                el-tooltip(placement='right')
                  div(slot='content', v-html='$t("force_overdue_hint")')
                  i.el-icon-question
              //- el-form-item(
              //-   :label="$t('equivalenceorcorrespondence3')",
              //-   v-show='isBachelor', class="forBachelor"
              //- )
                el-radio-group(v-model='correspondence', size='small', @change='correspondenceChanged')
                  el-radio-button(label='correspondence') {{$t("equivalenceorcorrespondence2")}}
                  el-radio-button(label='equality') {{$t("equivalenceorcorrespondence")}}
                el-tooltip(placement='right')
                  div(slot='content')
                    p(v-html="$t('hint_parity')")
                  i.el-icon-question
              //- el-alert(:closable='false',
              //-   v-if="!this.application.correspondence && this.application.degreeType=='bachelor'",
              //-   :title="$t('attention')"
              //-   type='warning' effect='dark' show-icon='')
              //- el-form-item(:label="$t('with')", v-show='isBachelor && application.applicationType !== "reappraisal"', class="forBachelor")
              //-   el-radio-group(v-model='application.recognitionWith', size='small')
              //-     el-radio-button(label='aeiAndTei') {{$t("uni_tei")}}
              //-     el-radio-button(label='aei') {{$t("university")}}
              //-     el-radio-button(label='tei') {{$t("tei")}}
                el-tooltip(placement='right')
                  div(slot='content')
                    span {{$t("hint_parity_with")}}
                  i.el-icon-question
              //- el-form-item(:label="$t('joint_assess')", v-show='isBachelor && application.applicationType !== "reappraisal"', class="forBachelor")
              //-   el-radio-group(v-model='consideration', size='small', @change='considerationChanged')
              //-     el-radio-button(label='consideration') {{$t("yes")}}
              //-     el-radio-button(label='noConsideration') {{$t("no")}}
              //-   el-tooltip(placement='right')
              //-     div(slot='content')
              //-       p(v-html="$t('hint_consideration')")
              //-     i.el-icon-question
              //- el-card.box-card(style="background-color: #fff")
              //-   .clearfix(slot='header')
              //-     span {{$t("hint_con")}}
              //-   .text.item
              //-     b
              //-       | {{conclusion}}
              //- br
              .govgr-card.govgr-card--border.govgr-card--border-gray
                .govgr-card
                  .govgr-card__body
                  span {{$t("hint_con")}} 
                    b {{conclusion}}
              //- .govgr-card.govgr-card--border.govgr-card--border-gray
              //-   .govgr-card
              //-     .govgr-card__body
              //- el-form-item(:label="$t('joint_assess')", v-show='isBachelor', class="forBachelor")
              //-   el-radio-group(v-model='consideration', size='small', @change='considerationChanged')
              //-     el-radio-button(label='consideration') {{$t("yes")}}
              //-     el-radio-button(label='noConsideration') {{$t("no")}}
              //-   el-tooltip(placement='right')
              //-     div(slot='content')
              //-       span {{$t("hint_parity_with")}}
              //-     i.el-icon-question
              el-form-item(:label="$t('joint_assess')", v-show='isBachelor', class="forBachelor")
                el-radio-group(v-model='consideration', size='small', @change='considerationChanged')
                  el-radio-button(label='noConsideration') {{$t("no")}}
                  el-radio-button(label='consideration') {{$t("yes")}}
                el-tooltip(placement='right')
                  div(slot='content')
                    <p v-html="$t('hint_consideration')"></p>
                    //- span {{ $t("hint_consideration") }}
                  i.el-icon-question
              template
                el-alert.wbreak(
                :closable='true' v-if="this.application.consideration && this.application.degreeType=='bachelor'"
                :title="$t('attention')"
                type='warning'
              )
                //- el-alert(:closable='false', v-if="this.application.consideration && this.application.degreeType=='bachelor'",
                //- :title="$t('attention')"
                //- type='warning' effect='dark' show-icon='')
              el-card.box-card(v-show="application.applicationType == 'recognition'")
                .clearfix(slot='header')
                  span {{$t("hint_con")}}
                .text.item
                  b
                    | {{conclusion}}
              el-card.box-card
                .clearfix(slot='header')
                  span {{ $t("I_confirm") }}
                .govgr-card.govgr-card--divider
                  .govgr-card__body
                  p(v-html="$t('I_confirmA')")
                  .govgr-card__action
                  el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.a',
                    style='float: right; padding: 0px 30px')
                  //- p(v-html="$t('I_confirmB')")
                  br
                .govgr-card.govgr-card--divider
                  .govgr-card__body
                  p(v-html="$t('I_confirmB')")
                  .govgr-card__action
                  el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.b',
                    style='float: right; padding: 0px 30px')
                  //- hr
                  //- p(v-html="$t('I_confirmC')")
                  br
                .govgr-card.govgr-card--divider
                  .govgr-card__body
                  p(v-html="$t('I_confirmC')")
                  .govgr-card__action
                  el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.c',
                    style='float: right; padding: 0px 30px')
                  br
                .govgr-card.govgr-card--divider
                  .govgr-card__body
                   p(v-html="$t('I_confirm_gdpr')")
                  a(:href="`../laravel/public/api/privacyconsentdeclaration?lang=${language}`") {{$t("consent_gdpr")}}
                  .govgr-card__action
                  el-checkbox(:label="$t('consent')", name='Αποδοχή', v-model='informed.f',
                    style='float: right; padding: 0px 65px')
                  br
                .govgr-card.govgr-card--divider
                  .govgr-card
                  a( :href="`../laravel/public/api/terms?lang=${language}`") {{$t("termsandcons")}}
                  .govgr-card__action
                  el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.d', style='float: right; padding: 0px 30px')
                  br
              //- el-card.box-card
              //-   .clearfix(slot='header')
              //-     span {{ $t("I_confirm") }}
              //-     br
              //-   .text.item
              //-     p(v-html="$t('I_confirmA')")
              //-     br
              //-     el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.a',
              //-       style='float: right; padding: 3px 0')
              //-     hr
              //-     p(v-html="$t('I_confirmB')")
              //-     br
              //-     el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.b',
              //-       style='float: right; padding: 3px 0')
              //-     hr
              //-     p(v-html="$t('I_confirmC')")
              //-     br
              //-     el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.c',
              //-       style='float: right; padding: 3px 0')
              //-     hr
              //-     a(:href="`../laravel/public/api/terms?lang=${language}`") {{$t("termsandcons")}}
              //-     br
              //-     el-checkbox(:label="$t('informed')", name='Ενημερώθηκα', v-model='informed.d',
              //-       style='float: right; padding: 3px 0')
              //-     hr
                    style='float: right; padding: 3px 60px')
              el-card.box-card
                .clearfix(slot='header')
                  span {{ $t("I_declare") }}
                  br
                el-checkbox(:label="$t('I_confirmD')", name='Ενημερώθηκα', v-model='informed.e',
                  style='float: left; padding: 3px 0')
                br
                br
                br
                el-radio-group(v-model='declared' style='float: left; padding: 3px 0')
                  el-radio(:label='true') {{ $t('I_confirmE') }}
                  el-radio(:label='false') {{ $t('I_confirmF') }}
          span.dialog-footer(slot='footer')
            el-button(
              type='primary',
              @click='selectAppType',
              v-show="pilotNewEdit === 'new'"
            ) {{$t("submit")}}
            el-button(
              type='primary',
              @click='submitNewEdit',
              v-show="pilotNewEdit === 'edit' && tempWorkingApplication.id"
            ) {{$t("view")}}
            //- el-button(type='primary', @click='findApplicationById', v-show="pilotNewEdit === 'edit'") Αναζήτηση με αριθμό
    el-row(v-show="!dialogSelectAppType")
      el-col(:xs='20', :sm='16', :md='14', :lg='10', :xl='8')
        el-card.box-card(shadow='hover' v-show='!showChangePass' ref="loginCard")
          .clearfix(slot='header')
            h3(align='center') {{$t("login")}}
          .text.item
            el-form(label-width='140px', :inline="true")
              el-form-item(label="Γλώσσα/Language", ref='languageSelect')
                el-radio-group(v-model='language' @change="changeLanguage")
                  el-radio(label='el') Ελληνικά
                  el-radio(label='en') English
            //- hr
            el-form.ruleForm(
              :model='loginForm',
              status-icon='',
              :rules='validationRules',
              ref='loginForm', label-width='80px'
            )
              span
                el-form-item(:label="$t('username')", prop='checkEmail')
                  el-input(type='name',
                    v-model='loginForm.email',
                    auto-complete='off',
                    v-on:keyup.enter.native="login"
                  )
                el-form-item(:label="$t('password')", prop='checkPassword')
                  el-input(
                    type='password',
                    v-model='loginForm.password',
                    auto-complete='off',
                    v-on:keyup.enter.native="login"
                  )
                <!--el-form-item(label='Υπάρχει ενεργή Αίτηση')-->
                  <!--el-checkbox(label='Ναι', name='active')-->
                div.buttons
                  el-button(type='primary', @click='login') {{$t("submission")}}
                  el-button(@click="resetForm('loginForm')") {{$t("erase")}}
        el-card.box-card(shadow='hover' v-show='showChangePass' ref="changePassCard")
          .clearfix(slot='header')
            h3(align='center') {{$t("changepass")}}
          .text.item
            el-form.ruleForm(
              :model='changePassForm',
              status-icon='',
              :rules='validationRules',
              ref='changePassForm',
              label-width='140px',
              auto-complete='off'
            )
              span
                el-form-item(:label="$t('newusername')", prop='checkEmail')
                  el-input(type='name', v-model='changePassForm.username', auto-complete='off')
                el-form-item(:label="$t('oldpass')", prop='checkPassword')
                  //- auto-coplete property to avoid browser auto-fill old password
                  el-input(type='password', v-model='changePassForm.oldPassword', auto-complete='new-password')
                el-form-item(:label="$t('newpass')", prop='checkPassword')
                  el-input(type='password', v-model='changePassForm.password', auto-complete='off')
                el-form-item(:label="$t('verify')", prop='checkPassword')
                  el-input(type='password', v-model='changePassForm.passwordConfirmation', auto-complete='off')
                el-form-item
                  el-button(type='primary', @click='submitChangePass') {{$t("submission")}}
                  el-button(@click="resetForm('changePassForm')") {{$t("erase")}}
</template>

<script>
import axios from 'axios'
import router from '../router/index'
import config from '../config.js'
import sharedMethods from './common/sharedMethods.js'

export default {
  name: 'Login',
  props: ['startNewApp'],
  mixins: [sharedMethods],
  mounted() {
    if (JSON.parse(sessionStorage.getItem('fromGGPS'))) {
      this.dialogSelectAppType = true
    } else {
      this.dialogSelectAppType = this.startNewApp
    }
    this.language = sessionStorage.getItem('selected_language') || 'el'
    this.$i18n.locale = this.language
  },
  data() {
    var validatePass = (rule, value, callback) => {
      // if (value === '') {
      //   callback(new Error('Please input the password'))
      // } else {
      //   if (this.loginForm.checkPassword !== '') {
      //     this.$refs.loginForm.validateField('checkPassword')
      //   }
      //   callback()
      // }
    }
    return {
      stagingEnv: config.STAGING_ENV,
      forceOverdue: false,
      isOverdue: false,
      declared: false,
      loadingFinalizedApps: false,
      finalizedApps: [],
      relevantAppId: null,
      tempWorkingApplication: {},
      gotApps: false,
      usersAllApplications: [],
      showChangePass: false,
      foreigner: false,
      greekUniversityDepartments: [],
      neededDocsGr: [],
      neededDocsEn: [],
      neededDocsIds: [],
      neededDocsMandatory: [],
      neededDocsInformation: [],
      neededDocsInformationGr: [],
      neededDocsInformationEng: [],
      application: {
        applicationType: '',
        degreeType: '',
        recognitionWith: 'aeiAndTei',
        consideration: false,
        correspondence: true,
        scoreMatch: false,
        personalDetails: {
          afm: '',
          name: '',
          surname: '',
          fatherName: '',
          motherName: '',
        },
      },
      externalUser: {},
      externalUserId: null,
      pilotNewEdit: null,
      transition: 'transition',
      consideration: 'noConsideration',
      correspondence: 'correspondence',
      language: 'el',
      informed: { a: false, b: false, c: false, d: false, e: false, f: false },
      dialogSelectAppType: false,
      loggingIn: false,
      findingCreatingApp: false,
      hasScope: false,
      options: [
        {
          value: 'Option1',
          label: 'Option1',
        },
        {
          value: 'Option2',
          label: 'Option2',
        },
      ],
      value3: '',
      changePassForm: {
        username: '',
        password: '',
        oldPassword: '',
        passwordConfirmation: '',
      },
      loginForm: {
        email: '',
        password: '',
      },
      validationRules: {
        checkPassword: [{ validator: validatePass, trigger: 'blur' }],
        checkEmail: [{ validator: validatePass, trigger: 'blur' }],
      },
      role: null,
      error: false,
    }
  },
  computed: {
    calcAllApps () {
      return this.usersAllApplications.length === 0
        ? ''
        : `<el-card>
            <div class="govgr-card govgr-card--border govgr-card--border-gray" style="word-break: break-word;"> ${this.usersAllApplications.map(app => {
                      return `<div govgr-card__text>${app.id}: ${this.language === 'el'? app.grApplicationType : app.engApplicationType}</div>` // στην κατάσταση: ${this.$i18n.t('app.applicationStatus')}
                    }).join('')}
            </div>
          </el-card>`
    },
    dialogSelectAppTypeSize() {
      console.log(window.innerWidth)
      if (window.innerWidth > 800) {
        return '60%'
      } else {
        return '100%'
      }
    },
    isBachelor() {
      return this.application.degreeType === 'bachelor'
    },
    conclusion() {
      let con = ''
      if (this.application.applicationType === 'recognition') {
        con = this.$i18n.t('conclusion')
        if (this.application.degreeType === 'bachelor') {
          if (this.application.correspondence) {
            con += this.$i18n.t('conclusion3')
            con += this.$i18n.t('conclusion2')
          } 
          else {
            con += this.$i18n.t('conclusion4')
          }
          // if (this.application.recognitionWith === 'aeiAndTei') {
          //   con += this.$i18n.t('conclusion5')
          // } else if (this.application.recognitionWith === 'aei') {
          //   con += this.$i18n.t('conclusion6')
          // } else if (this.application.recognitionWith === 'tei') {
          //   con += this.$i18n.t('conclusion7')
          // }
          if (this.application.consideration) {
            con += this.$i18n.t('conclusion8')
          } else {
            // con += this.$i18n.t('conclusion13')
          }
        } else if (this.application.degreeType === 'master') {
          con += this.$i18n.t('conclusion3')
          con += this.$i18n.t('conclusion9')
          // if (this.application.scoreMatch) {
          //   con += this.$i18n.t('conclusion10')
          // } else {
          //   con += this.$i18n.t('conclusion11')
          // }
        } else if (this.application.degreeType === 'phd') {
          con += this.$i18n.t('conclusion3')
          con += this.$i18n.t('conclusion12')
        }
      } else if (this.application.applicationType === 'reappraisal') {
        con = this.$i18n.t('conclusion13')

      }
      return con
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = this.language
    },
    submitChangePass() {
      if (
        this.changePassForm.username !== '' &&
        this.changePassForm.password !== '' &&
        this.changePassForm.passwordConfirmation !== ''
      ) {
        if (
          this.changePassForm.password ===
          this.changePassForm.passwordConfirmation
        ) {
          this.loggingIn = true
          this.$confirm(this.$t('change_pass'), this.$t('warning'), {
            confirmButtonText: 'OK',
            cancelButtonText: 'Άκυρο',
            type: 'warning',
          })
            .then(() => {
              axios
                .patch(
                  `${config.BASE_URL}/foreignusers`,
                  {
                    username: this.changePassForm.username,
                    password: this.changePassForm.password,
                    oldPassword: this.changePassForm.oldPassword,
                  }
                )
                .then(response => {
                  this.loggingIn = false
                  this.$emit('logout', '')
                  window.location.href = config.ENTRANCE_URL
                })
                .catch(err => {
                  this.backendErrorNotify(err)
                })
            })
            .catch(err => {
              this.loggingIn = false
              this.backendErrorNotify(err)
            })
        } else {
          this.$notify.warning({
            title: this.$t('warning'),
            message: this.$t('same_pass_msg'),
            offset: 100,
          })
        }
      } else {
        this.$notify.warning({
          title: this.$t('warning'),
          message: this.$t('fill_in'),
          offset: 100,
        })
      }
    },
    findApplicationById() {
      axios
        .get(
          `${config.BASE_URL}/users/uid/applications/${this.application.id}`
        )
        .then(response => {})
    },
    submitNewEdit() {
      this.application = this.tempWorkingApplication
      this.$i18n.locale = this.application.language ? this.application.language : 'el'
      this.emitAndStore(
        this.neededDocsGr,
        this.neededDocsEn,
        this.neededDocsIds,
        this.neededDocsInformation,
        this.neededDocsInformationGr,
        this.neededDocsInformationEng,
        this.neededDocsMandatory,
        this.countries,
        this.externalUserId,
        this.greekUniversityDepartments,
        this.application,
        this.usersAllApplications
      )
      this.dialogSelectAppType = false
      router.replace('/userApply')
    },
    findApplication() {
      this.$store.dispatch('GET_APPLICATIONS')
      if (!this.gotApps) {
        this.findingCreatingApp = true
        return axios
          .get(`${config.BASE_URL}/usersAllApplications`)
          .then(response => {
            this.gotApps = true
            if (response.data.success) {
              this.tempWorkingApplication = response.data.data.workingApplication
              // this.$i18n.locale = this.application.language ? this.application.language : 'el'
              response.data.data.workingApplication.neededDocuments.forEach(
                doc => {
                  this.neededDocsGr.push(doc.grName)
                  this.neededDocsEn.push(doc.engName)
                  this.neededDocsIds.push(doc.id)
                  this.neededDocsInformation.push(doc.information)
                  this.neededDocsInformationGr.push(doc.grInformation)
                  this.neededDocsInformationEng.push(doc.engInformation)
                  this.neededDocsMandatory.push(doc.mandatory)
                }
              )
              this.usersAllApplications = response.data.data.allApplications
              this.countries = response.data.data.countries
              this.externalUserId = response.data.data.userId
              this.findingCreatingApp = false
              sessionStorage.setItem(
                'usersAllApplications',
                JSON.stringify(this.usersAllApplications)
              )
            }
          })
          .catch(err => {
            console.log('error' + err)
            this.gotApps = true
            this.$emit('newApplication')
            router.replace('/login')
            this.findingCreatingApp = false
            if (this.pilotNewEdit !== 'new') { this.backendErrorNotify(err) }
          })
      } 
    },
    selectAppType() {
      if (
        (this.application.applicationType === 'recognition' && this.application.degreeType !== '' && 
        Object.keys(this.informed).every((k) => this.informed[k] === true)) ||
        (this.application.applicationType === 'reappraisal' && this.relevantAppId && 
        Object.keys(this.informed).every((k) => this.informed[k] === true))
      ) {
        let requestBody = {
          language: this.language,
          applicationType: this.application.applicationType,
          // degreeType: this.application.degreeType,
        }
        if (this.application.applicationType === 'recognition') {
          requestBody.degreeType = this.application.degreeType
          if (this.application.degreeType === 'bachelor') {
            requestBody.correspondence = this.application.correspondence
            requestBody.consideration = this.application.consideration
            requestBody.recognitionWith = this.application.recognitionWith
          } else if (this.application.degreeType === 'master') {
            requestBody.scoreMatch = this.application.scoreMatch
          }
        } else if (this.application.applicationType === 'reappraisal') {
          requestBody.relevantAppId = this.relevantAppId
          var today = new Date()
          // let reappraisalDate = new Date(this.finalizedApps.find(app => app.id === this.relevantAppId).finalizedDate.replace(/-/g, '/'))
          let reappraisalDate = new Date(this.finalizedApps.find(app => app.id === this.relevantAppId).actDownloadedAt.replace(/-/g, '/'))
          // let diff = 10 - Math.floor(0.5 + (today - reappraisalDate) / 86400000)
          let diff = today.getTime() - reappraisalDate.getTime()
          var days = Math.ceil(diff / (1000 * 3600 * 24))
          // requestBody.overdue = days > 365
          this.isOverdue = days > config.OVERDUE_PERIOD
          requestBody.forceOverdue = this.stagingEnv && this.forceOverdue
        }
        let confirmMesg = this.isOverdue || requestBody.forceOverdue ? this.$t('overdue_warning') : this.$t('submit_warning')
        this.$confirm(confirmMesg, {
          confirmButtonText: this.$t('button_yes'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
            // post new application with its type and receive neededDocument
            this.findingCreatingApp = true
            axios
              .post(
                `${config.BASE_URL}/externalusers/userid/applications`, // fromintusers/applications`,
                requestBody
              )
              .then(response => {
                this.neededDocsGr = []
                this.neededDocsEn = []
                this.neededDocsIds = []
                this.neededDocsInformation = []
                this.neededDocsInformationGr = []
                this.neededDocsInformationEng = []
                this.neededDocsMandatory = []
                response.data.data.neededDocuments.forEach(doc => {
                  this.neededDocsGr.push(doc.grName)
                  this.neededDocsEn.push(doc.engName)
                  this.neededDocsIds.push(doc.id)
                  this.neededDocsInformation.push(doc.information)
                  this.neededDocsInformationGr.push(doc.grInformation)
                  this.neededDocsInformationEng.push(doc.engInformation)
                  this.neededDocsMandatory.push(doc.mandatory)
                })
                this.countries = response.data.data.countries
                this.externalUser = response.data.data.user
                this.findingCreatingApp = false
                this.externalUserId = response.data.data.user.id
                this.application = response.data.data.workingApplication
                this.dialogSelectAppType = false
                this.usersAllApplications = response.data.data.allApplications
                this.emitAndStore(
                  this.neededDocsGr,
                  this.neededDocsEn,
                  this.neededDocsIds,
                  this.neededDocsInformation,
                  this.neededDocsInformationGr,
                  this.neededDocsInformationEng,
                  this.neededDocsMandatory,
                  this.countries,
                  this.externalUserId,
                  this.greekUniversityDepartments,
                  this.application,
                  this.usersAllApplications
                )
                router.replace('/userApply')
                // this.savingApplication = false
              })
              .catch(err => {
                this.backendErrorNotify(err)
                this.findingCreatingApp = false
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('fill_in_all_fields')
            })
          })
      } else 
        this.$notify.warning({
          title: this.$t('warning'),
          message: this.$t('fill_confirm'),
          offset: 100,
        })

    },
    emitAndStore(
      neededDocsGr,
      neededDocsEn,
      neededDocsIds,
      neededDocsInformation,
      neededDocsInformationGr,
      neededDocsInformationEng,
      neededDocsMandatory,
      countries,
      externalUserId,
      greekUniversityDepartments,
      workingApplication,
      usersAllApplications
    ) {
      this.$emit('neededDocsGr', neededDocsGr)
      this.$emit('neededDocsEn', neededDocsEn)
      this.$emit('neededDocsIds', neededDocsIds)
      this.$emit('neededDocsInformation', {en: neededDocsInformationEng, el: neededDocsInformationGr})
      // this.$emit('neededDocsInformationGr', neededDocsInformationGr)
      // this.$emit('neededDocsInformationEng', neededDocsInformationEng)
      this.$emit('neededDocsMandatory', neededDocsMandatory)
      this.$emit('countries', countries)
      this.$emit('externalUserId', externalUserId)
      if (!sessionStorage.getItem('currentUser')) {
        this.$emit('userLoggedIn', externalUserId)
      }
      this.$emit('greekUniversityDepartments', greekUniversityDepartments)
      this.$emit('workingApplication', workingApplication)
      this.$emit('usersAllApplications', usersAllApplications)
      sessionStorage.setItem('neededDocsGr', JSON.stringify(neededDocsGr))
      sessionStorage.setItem('neededDocsEn', JSON.stringify(neededDocsEn))
      sessionStorage.setItem('neededDocsIds', JSON.stringify(neededDocsIds))
      sessionStorage.setItem(
        'neededDocsInformation',
        JSON.stringify(neededDocsInformation)
      )
      sessionStorage.setItem(
        'neededDocsInformationGr',
        JSON.stringify(neededDocsInformationGr)
      )
      sessionStorage.setItem(
        'neededDocsInformationEng',
        JSON.stringify(neededDocsInformationEng)
      )
      sessionStorage.setItem(
        'neededDocsMandatory',
        JSON.stringify(neededDocsMandatory)
      )
      sessionStorage.setItem('countries', JSON.stringify(countries))
      sessionStorage.setItem('externalUserId', JSON.stringify(externalUserId))
      sessionStorage.setItem(
        'greekUniversityDepartments',
        JSON.stringify(greekUniversityDepartments)
      )
      sessionStorage.setItem(
        'workingApplication',
        JSON.stringify(workingApplication)
      )
      sessionStorage.setItem(
        'usersAllApplications',
        JSON.stringify(usersAllApplications)
      )
    },
    transitionChanged(transition) {
      this.application.transition = transition === 'transition'
    },
    considerationChanged(consideration) {
      this.application.consideration = consideration === 'consideration'
    },
    correspondenceChanged(correspondence) {
      this.application.correspondence = correspondence === 'correspondence'
    },
    degreeLevelChanged(degree) {
      if (degree === 'master' || degree === 'phd') {
        this.application.consideration = false
        this.consideration = 'noConsideration'
        this.correspondence = 'equality'
        this.application.correspondence = false
      } else {
        this.application.consideration = false
        this.consideration = 'noConsideration'
        this.correspondence = 'correspondence'
        this.application.correspondence = true
      }
    },
    appTypeChanged () {
      if (this.application.applicationType === 'reappraisal') {
        this.application.correspondence = false
        this.application.consideration = false
        this.application.degreeType = ''
        this.loadingFinalizedApps = true
        axios
        .get(`${config.BASE_URL}/usersAllApplications?reappraisal=1`)
        .then(response => {
          this.finalizedApps = response.data.data.allApplications
          this.loadingFinalizedApps = false
          if (this.finalizedApps.length === 0) {
             this.$notify.warning({
               title: this.$t('warning'),
               message: this.$t('finalizedAppsMsg'),
               offset: 100,
              })
          }
        }
      )}
    },
    reappraisalAppChanged () {
      console.log(this.relevantAppId)
    },
    register() {},
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      if (formName === 'loginForm') {
        this.loginForm.email = ''
        this.loginForm.password = ''
      } else {
        this.changePassForm.username = ''
        this.changePassForm.password = ''
        this.changePassForm.passwordConfirmation = ''
      }
    },
    login() {
      if (this.loginForm.email !== '' && this.loginForm.password !== '') {
        this.loggingIn = true
        axios
          .post(
            `${config.BASE_URL}/login/foreignusers`,
            { name: this.loginForm.email, password: this.loginForm.password },
            { headers: { 'Content-type': 'application/json' } }
          )
          .then(response => {
            if (!response.data.data.access_token) {
              return
            }
            this.loggingIn = false
            // if foreign first time dont open dialog but change username-password
            if (response.data.data.scope.includes('TemporaryForeignUser')) {
              this.showChangePass = true
              this.dialogSelectAppType = false
              sessionStorage.token = response.data.data.access_token
              this.$emit('userLoggedIn', response.data.data.user.name)
            } else if (response.data.data.scope.includes('Applicant')) {
              this.showChangePass = false
              this.dialogSelectAppType = true
              sessionStorage.token = response.data.data.access_token
              this.$emit('userLoggedIn', response.data.data.user.name)
            } else {
              this.$emit('logout', '')
              router.replace('/login')
              this.$notify.warning({
                title: this.$t('warning'),
                message: this.$t('wrong_credentials'),
                offset: 100,
              })
            }
            // router.replace('/userApply')
          })
          .catch(err => {
            this.$emit('logout', '')
            router.replace('/login')
            this.loggingIn = false
            this.backendErrorNotify(err)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

a:link { 
  text-decoration: none; 
  color:#0149A7;
}

a:visited { 
  text-decoration: none; 
  color:#4c2b91;
}

a:hover{
  text-decoration: none;
  color:#003375;
}

a:active {
  text-decoration: none;
  color:#212930;
}

.wbreak {
  word-break: break-word
}

.buttons {
  display: flex;
  justify-content: center;
}

.el-select {
  &.big {
    width: 300px;
  }
  &.bigger {
    width: 350px;
  }
}

.el-card {
  // background-color: #b3c0d1;
  background-color:#b3b2b3;
  word-break: break-word;
}
.el-row {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 60px;
}
.bg-purple {
  background: #d3dce6;
}
body {
  background: rgb(255, 255, 255);
}
</style>
